// React
import React from "react";
import PropTypes from "prop-types";
// i18next
import { withNamespaces } from "react-i18next";
// Styles
import styles from "./TransactionStateLabel.css";

const TransactionStates = {
  NotSet: -1,
  Initialization: 0,
  PendingWaitingForNotification: 1,
  Cancelled: 2,
  Failed: 3,
  Success: 4,
  Deleted: 5,
  AuthorisationRefused: 6,
  Refunded: 7
};

const TransactionStateLabel = ({ transactionState, transactionStateL10n, t }) => {
  return (
    <span
      style={styles.transactionStateLabel}
      class={getTransactionStateLabelClass(transactionState)}
    >
      {t(transactionStateL10n)}
    </span>
  );
};

function getTransactionStateLabelClass(transactionState) {
  switch (transactionState) {
    case TransactionStates.Initialization:
      return "label-info";

    case TransactionStates.PendingWaitingForNotification:
      return "label-primary";

    case TransactionStates.Success:
      return "label-success";

    case TransactionStates.Refunded:
      return "bg-color-darken";

    case TransactionStates.Cancelled:
      return "label-warning";

    case TransactionStates.Failed:
    case TransactionStates.AuthorisationRefused:
      return "label-danger";

    case TransactionStates.NotSet:
    case TransactionStates.Deleted:
    default:
      return "label-default";
  }
}

TransactionStateLabel.propTypes = {
  transactionState: PropTypes.number.isRequired,
  transactionStateL10n: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
};

export default withNamespaces()(TransactionStateLabel);
